/**
 * @typedef {import('vue').ComponentOptions<Vue>} VueComponent
 */

/** @type {VueComponent} */

import { gsap } from 'gsap';
import Vue from 'vue';

export default {
    props: {
        feature: {
            type: Object,
        },
    },

    data() {
        return {
            selectedBlock: this.feature.block[0],
            isDarkVariant: false,

            selectedColorHash: null,
            selectedColorName: null,
            selectedAssets: null,
        };
    },

    mounted() {
        if ('isDarkVariant' in this.$parent) {
            this.isDarkVariant = this.$parent.isDarkVariant;
        }
        if ('isSpecialMicrosite' in this.$parent) {
            this.isSpecialMicrosite = this.$parent.isSpecialMicrosite;
        }
        this.handleToggleBlockVisibility(this.selectedBlock, 'auto');
        this.handleSetAssets();
    },

    watch: {
        selectedBlock: function (newBlock, oldBlock) {
            if (newBlock.title === oldBlock.title) return;
            this.handleToggleBlockVisibility(oldBlock, 0);
            this.handleToggleBlockVisibility(newBlock, 'auto');
            this.handleSetAssets();
        },
    },

    components: {
        'model-features-accordion-swiper': () =>
            import('./async-features-accordion-swiper'),
        'model-features-accordion-swiper-mobile': () =>
            import('./async-features-accordion-swiper-mobile'),
    },

    methods: {
        changeColor(colorHash) {
            const foundColorPicker = this.selectedBlock.colorPicker.find(
                (colorPicker) => colorPicker.colorHash === colorHash,
            );
            this.selectedAssets = foundColorPicker.urlToCarImage;
            this.selectedColorHash = colorHash;
            this.selectedColorName = foundColorPicker.colorName;
        },

        setActiveButtonClass(colorHash) {
            return this.selectedColorHash === colorHash
                ? 'slider-section-features__color-picker-button--active'
                : '';
        },

        handleSetAssets() {
            const colorPicker = this.selectedBlock.colorPicker;
            const doesColorPickerExist = colorPicker.length > 0;
            if (doesColorPickerExist) {
                this.selectedColorHash = colorPicker[0].colorHash;
                this.selectedColorName = colorPicker[0].colorName;
            }

            this.selectedAssets = doesColorPickerExist
                ? this.selectedBlock.colorPicker[0].urlToCarImage
                : this.selectedBlock.assets;
        },

        slugifyTitle(title) {
            return title.replace(/\s+/g, '-').toLowerCase();
        },

        handleContentPosition(imagePosition) {
            return `slider-section-features__container--${imagePosition}${
                this.isDarkVariant
                    ? '--dark'
                    : this.isSpecialMicrosite
                    ? '--microsite'
                    : ''
            }`;
        },

        handleToggleBlockVisibility(block, blockHeight) {
            this.selectedBlock = block;
            const elementId = this.slugifyTitle(block.title);

            const element = document
                .getElementById(elementId)
                .querySelector('.slider-section-features__text');

            gsap.timeline().to(element, {
                duration: 0.7,
                height: blockHeight,
                ease: 'power4.out',
            });
        },

        setButtonClass(title) {
            const normalClass = `slider-section-features__title ${
                this.isDarkVariant ? 'slider-section-features__title--dark' : ''
            }`;
            const activeClass = this.isDarkVariant
                ? 'slider-section-features__title--dark--active'
                : 'slider-section-features__title--active';

            return title === this.selectedBlock.title
                ? `${normalClass} ${activeClass}`
                : normalClass;
        },

        isToggleActive(title) {
            return title === this.selectedBlock.title;
        },

        setTextClass() {
            return `slider-section-features__text ${
                this.isDarkVariant ? 'slider-section-features__text--dark' : ''
            }`;
        },

        setButtonBorderColor() {
            return this.isDarkVariant
                ? 'slider-section-features__text-container--dark-border'
                : '';
        },
    },
};
